<style>
.no-items-row {
  color: rgb(102, 102, 102);
  font-size: 14px;
  padding: 10px 0px;
}
.b-table-sticky-header {
    overflow-y: scroll;
    max-height: 500px;
    width: 100%;
}
.b-table-sticky-header, .table-responsive, [class*=table-responsive-] {
    margin-bottom: 1rem;
}
.b-table-sticky-header>.table.b-table>thead>tr>th {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 999;
    background: white;
    border: 1px;
}
.action-column-header, .action-column-cell{
  position: -webkit-sticky;
  position: sticky;
  right: 0;
}
.action-column-cell {
  background: white;
}
.alert-badge {
  z-index: 998 !important;
}
</style>

<template>
  <b-row>
    <b-col>
      <b-row v-if="showFilter">
        <b-col md="4">
          <b-form-input v-model="filter" placeholder="Filter" aria-label="Filter">
          </b-form-input>
        </b-col>
        <b-col>
          <slot name="header"></slot>
        </b-col>
      </b-row>
      <b-row>
        <slot name="hint"></slot>
      </b-row>
      <b-row class="mt-3">
        <b-col>
          <b-table
            ref="table"
            responsive hover
            :class="`${stickyHeader ? 'b-table-sticky-header':''}`"
            :items="items"
            :fields="fields"
            :filter="filter"
            :filter-function="filterFunction"
            :sort-compare="sortCompare"
            :show-empty="showEmpty"
            :empty-text="emptyText"
            :empty-filtered-text="emptyFilteredText"
            :primary-key="primaryKey"
            :tbody-tr-class="rowClass"
            @row-clicked="(item, index) => $emit('row-clicked', item, index)"
          >
            <template :slot="slot.key" slot-scope="row" v-for="slot in slots">
              <slot :name="slot.key" :value="row.item[slot.key]" :row="row"></slot>
            </template>
            <template v-slot:empty="scope">
              <div class="no-items-row text-center">
                {{ scope.emptyText }}
              </div>
            </template>
            <template v-slot:emptyfiltered="scope">
              <div class="no-items-row text-center">
                {{ scope.emptyFilteredText }}
              </div>
            </template>
            <template #bottom-row>
              <td colspan="100%">
                <slot name="caption"></slot>
              </td>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>


<script>
export default {
  props: {
    slots: {
      type: Array,
    },
    items: {
      type: Array,
      required: true,
    },
    fields: {
      type: Array,
      required: true,
    },
    clickable: {
      type: Boolean,
      default() { return false; },
    },
    showFilter: {
      type: Boolean,
      default() { return true; },
    },
    filterFunction: Function,
    sortCompare: Function,
    emptyText: String,
    primaryKey: [String, Number],
    showEmpty: {
      type: Boolean,
      default: true,
    },
    stickyHeader: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      filter: null,
      mounted: false,
    };
  },
  mounted() {
    this.mounted = true;
  },
  computed: {
    emptyFilteredText() {
      return `No records matching "${this.filter}".`;
    },
    rowClass(item) {
      if (!this.mounted || !item) { return null; }
      const table = this.$refs.table;
      let classes = this.clickable && table.filteredItems.length > 0 ? 'pointer-cursor' : '';

      /* eslint no-underscore-dangle: ["error", { "allow": ["_trClass"] }] */
      if (item._trClass) {
        classes += ` ${item._trClass}`;
      }

      return classes;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/utils/FilterTable.vue